// extracted by mini-css-extract-plugin
export default {"main":"ImageContainer_main__5zwJw","imageButton":"ImageContainer_imageButton__aA-2d","delete":"ImageContainer_delete__Qls4V"};